<script setup>
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import Contact from './contacts/Index.vue';

const emit = defineEmits(['submit']);

const form = ref({
  contact_ids: [],
});

const rules = {
  contact_ids: {
    required,
  },
};

const v$ = useVuelidate(rules, form);

const setForm = newForm => {
  form.value = { ...newForm };
};

const setContactIds = ids => {
  setForm({ ...form.value, contact_ids: ids });
};

const handleSubmit = () => {
  emit('submit');
};

const validate = () => {
  return v$.value.$validate();
};

defineExpose({ form, validate, setForm });
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="handleSubmit">
    <Contact :contact-ids="form.contact_ids" @update="setContactIds" />
  </form>
</template>
